import React, { useEffect, useState } from "react";
import { fetchApi } from "../helper/api";
import { IsAlert } from "../component/atoms/IsAlert";
import { Link } from "react-router-dom";
import InputUser from "../component/molecules/popup/InputUser";
import EditUser from "../component/molecules/popup/EditUser";
const $ = require("jquery");
$.Datatable = require("datatables.net");

class UserManagememt extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      dataWaiting: null,
      dataReject: null,
      dataEdit: null,
    };
  }
  componentDidMount() {
    this.getdata();
    // this.setDefaultDate()
  }
  getdata = async () => {
    var req = await fetchApi("api/User?filter=approved", "GET", true);
    var res = await req.json();
    var reqWaiting = await fetchApi("api/User?filter=waiting", "GET", true);
    var resWaiting = await reqWaiting.json();
    var reqReject = await fetchApi("api/User?filter=rejected", "GET", true);
    var resReject = await reqReject.json();
    this.setState(
      {
        data: res.data,
        dataWaiting: resWaiting.data,
        dataReject: resReject.data,
      },
      function () {
        this.setDatatable();
      }
    );
  };
  setDatatable = () => {
    var self = this;
    this.$al = $(this.al);
    this.$al.DataTable({
      bLengthChange: false,
      bInfo: true,
      language: { searchPlaceholder: "Search...", search: "" },
      bDestroy: true,
      data: this.state.data,
      columns: [
        {
          width: 20,
          title: "No.",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            return meta.row + 1;
          },
        },
        {
          title: "Email",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            return data.email;
          },
        },
        {
          title: "Last Login",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            return new Date(data.lastLogin).toLocaleString();
          },
        },
        {
          title: "Role",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            // let rand = Math.random() * 2;
            return data.role;
            // if (data.role > 5) {
            //     return "<div class='badge rounded py-1 badge-flat-success' style='width:80px'>Super Admin</div>"
            // }
            // else {
            //     return "<div class='badge rounded py-1 badge-flat-warning' style='width:80px'>User</div>"
            // }
          },
        },
        {
          title: "Approval",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            // let rand = Math.random() * 2;
            // rand = Math.floor(rand);
            if (!data.isApproved) {
              return "<div class='d-flex justify-content-center'><div class='rounded-circle bg-danger d-flex align-items-center justify-content-center' style='width: 30px; height: 30px'><i class='las la-user-times'></i></div></div>";
            } else {
              return "<div class='d-flex justify-content-center'><div class='rounded-circle bg-success d-flex align-items-center justify-content-center' style='width: 30px; height: 30px'><i class='las la-user-check'></i></div></div>";
            }
          },
        },
        {
          width: 190,
          title: "Opsi",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            if (data.isApproved) {
              return `<div class="d-flex">
                                        <button class="btn btn-info d-flex align-items-center editData text-nowrap mr-1" data-toggle="modal" data-target="#EditUser_modal" data-id="${data.email}" data-role="${data.role}">
                                            <i class="las la-edit text-white" style="font-size: 20px"></i>
                                        </button>
                                        <button class="btn btn-danger  d-flex align-items-center deleteData text-nowrap" data-email="${data.email}">
                                            <i class="las la-trash-alt text-white" style="font-size: 20px"></i>
                                        </button>
                                    </div>
                                `;
            } else {
              return `<div class="d-flex">
                                        <button class="btn btn-success  d-flex align-items-center approveUser text-nowrap" data-nama="${data.email}">
                                            <i class="las la-check-circle text-white" style="font-size: 20px"></i>
                                        </button>
                                        <button class="btn btn-danger d-flex align-items-center rejectUser text-nowrap" data-nama="${data.email}">
                                            <i class="las la-times-circle text-white" style="font-size: 20px"></i>
                                        </button>
                                    </div>
                                `;
            }
          },
        },
      ],
    });
    this.$el = $(this.el);
    this.$el.DataTable({
      bLengthChange: false,
      bInfo: true,
      language: { searchPlaceholder: "Search...", search: "" },
      bDestroy: true,
      data: this.state.dataWaiting,
      columns: [
        {
          width: 20,
          title: "No.",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            return meta.row + 1;
          },
        },
        {
          title: "Email",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            return data.email;
          },
        },
        {
          title: "Last Login",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            return new Date(data.lastLogin).toLocaleString();
          },
        },
        {
          title: "Role",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            // let rand = Math.random() * 2;
            return data.role;
            // if (data.role > 5) {
            //     return "<div class='badge rounded py-1 badge-flat-success' style='width:80px'>Super Admin</div>"
            // }
            // else {
            //     return "<div class='badge rounded py-1 badge-flat-warning' style='width:80px'>User</div>"
            // }
          },
        },
        {
          title: "Approval",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            // let rand = Math.random() * 2;
            // rand = Math.floor(rand);
            if (!data.approved) {
              return "<div class='d-flex justify-content-center'><div class='rounded-circle bg-danger d-flex align-items-center justify-content-center' style='width: 30px; height: 30px'><i class='las la-user-times'></i></div></div>";
            } else {
              return "<div class='d-flex justify-content-center'><div class='rounded-circle bg-success d-flex align-items-center justify-content-center' style='width: 30px; height: 30px'><i class='las la-user-check'></i></div></div>";
            }
          },
        },
        {
          width: 190,
          title: "Opsi",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            if (data.approved) {
              return `<div class="d-flex">
                                        <button class="btn btn-info d-flex align-items-center editData text-nowrap mr-1" data-toggle="modal" data-target="#EditUser_modal" data-id="${data.email}" data-role="${data.role}">
                                            <i class="las la-edit text-white" style="font-size: 20px"></i>
                                        </button>
                                        <button class"btn btn-danger  d-flex align-items-center deleteData text-nowrap" data-email="${data.email}">
                                            <i class="las la-trash-alt text-white" style="font-size: 20px"></i>
                                        </button>
                                    </div>
                                `;
            } else {
              return `<div class="d-flex">
                                        <button class="btn btn-success  d-flex align-items-center approveUser text-nowrap" data-nama="${data.email}">
                                            <i class="las la-check-circle text-white" style="font-size: 20px"></i>
                                        </button>
                                        <button class="btn btn-danger d-flex align-items-center rejectUser text-nowrap" data-nama="${data.email}">
                                            <i class="las la-times-circle text-white" style="font-size: 20px"></i>
                                        </button>
                                    </div>
                                `;
            }
          },
        },
      ],
    });
    this.$dul = $(this.dul);
    this.$dul.DataTable({
      bLengthChange: false,
      bInfo: true,
      language: { searchPlaceholder: "Search...", search: "" },
      bDestroy: true,
      data: this.state.dataReject,
      columns: [
        {
          width: 20,
          title: "No.",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            return meta.row + 1;
          },
        },
        {
          title: "Email",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            return data.email;
          },
        },
        {
          title: "Last Login",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            return new Date(data.lastLogin).toLocaleString();
          },
        },
        {
          title: "Role",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            // let rand = Math.random() * 2;
            return data.role;
            // if (data.role > 5) {
            //     return "<div class='badge rounded py-1 badge-flat-success' style='width:80px'>Super Admin</div>"
            // }
            // else {
            //     return "<div class='badge rounded py-1 badge-flat-warning' style='width:80px'>User</div>"
            // }
          },
        },
        {
          title: "Approval",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            // let rand = Math.random() * 2;
            // rand = Math.floor(rand);
            if (!data.isApproved) {
              return "<div class='d-flex justify-content-center'><div class='rounded-circle bg-danger d-flex align-items-center justify-content-center' style='width: 30px; height: 30px'><i class='las la-user-times'></i></div></div>";
            } else {
              return "<div class='d-flex justify-content-center'><div class='rounded-circle bg-success d-flex align-items-center justify-content-center' style='width: 30px; height: 30px'><i class='las la-user-check'></i></div></div>";
            }
          },
        },
        {
          width: 190,
          title: "Opsi",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            return "";
            // if (data.isApproved) {
            //     return (
            //         `<div class="d-flex">
            //             <button class="btn btn-info d-flex align-items-center editData text-nowrap mr-1" data-toggle="modal" data-target="#EditUser_modal" data-id="${data.email}" data-role="${data.role}">
            //                 <i class="las la-edit text-white" style="font-size: 20px"></i>
            //             </button>
            //             <button class="btn btn-danger  d-flex align-items-center deleteData text-nowrap" data-email="${data.email}">
            //                 <i class="las la-trash-alt text-white" style="font-size: 20px"></i>
            //             </button>
            //         </div>
            //     `
            //     )
            // }
            // else {
            //     return (
            //         `<div class="d-flex">
            //             <button class="btn btn-success  d-flex align-items-center approveUser text-nowrap" data-nama="${data.email}">
            //                 <i class="las la-check-circle text-white" style="font-size: 20px"></i>
            //             </button>
            //             <button class="btn btn-danger d-flex align-items-center rejectUser text-nowrap" data-nama="${data.email}">
            //                 <i class="las la-times-circle text-white" style="font-size: 20px"></i>
            //             </button>
            //         </div>
            //     `
            //     )
            // }
          },
        },
      ],
    });

    $(".editData").click(function (e) {
      e.preventDefault();
      var email = $(this).data("id");
      var role = $(this).data("role");
      self.setState({ dataEdit: { email: email, role: role } });
    });

    $(".lihaDetail").click(function (e) {
      e.preventDefault();
      // self.props.router.push("/on-boarding/calon-agen/123/data-calon-agen")
    });
    $(".rejectUser").click(function (e) {
      e.preventDefault();
      var userName = $(this).data("nama");
      IsAlert.fire({
        title: "",
        text: "Reject user " + userName + " ?",
        icon: "warning",
        focusConfirm: true,
        confirmButtonText: "OK",
        showCancelButton: true,
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
          fetchApi("api/Auth/rejectApprove", "POST", true, { email: userName });
          // navigate("/login")
        }
      });
    });
    $(".approveUser").click(function (e) {
      e.preventDefault();
      var userName = $(this).data("nama");
      IsAlert.fire({
        title: "",
        text: "Terima user " + userName + " ?",
        icon: "question",
        focusConfirm: true,
        confirmButtonText: "OK",
        showCancelButton: true,
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
          fetchApi("api/Auth/giveApprove", "POST", true, { email: userName });
          // navigate("/login")
        }
      });
    });
    $(".deleteData").click(function (e) {
      e.preventDefault();
      var email = $(this).data("email");
      IsAlert.fire({
        title: "",
        text: "Apakah anda yakin untuk menghapus akun ini?",
        icon: "warning",
        focusConfirm: true,
        confirmButtonText: "OK",
        showCancelButton: true,
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
          self.deleteUser(email);
          // navigate("/login")
        }
      });
    });
    var anu = $(".dataTables_filter");
    $(".wadah").html(anu);
  };
  deleteUser = async (id) => {
    var req = await fetchApi("api/User", "DELETE", true, {
      email: id,
    });
    var status = req.status;
    if (status === 200) {
      this.getdata();
    }
  };
  reloadData = () => {
    this.getdata();
  };
  render() {
    return (
      <div className="p-2">
        <InputUser reloadData={this.reloadData} />
        <EditUser dataEdit={this.state.dataEdit} />
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h1 className="mb-0">User</h1>
          <div mr-2>
            <span
              className="btn btn-success w-100 d-flex align-items-center"
              data-toggle="modal"
              data-target="#InputUser_modal"
            >
              <i className="las la-plus f-19 mr-2"></i>
              <span>Input Data</span>
            </span>
          </div>
        </div>
        <ul className="nav nav-tabs mb-3" id="pills-tab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              data-toggle="pill"
              data-target={`#disetujui`}
              type="button"
              role="tab"
              aria-selected="true"
            >
              Disetujui
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              data-toggle="pill"
              data-target={`#waiting`}
              type="button"
              role="tab"
              aria-selected="true"
            >
              Menunggu Konfirmasi
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              data-toggle="pill"
              data-target={`#ditolak`}
              type="button"
              role="tab"
              aria-selected="true"
            >
              Ditolak
            </button>
          </li>
        </ul>
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="disetujui"
            role="tabpanel"
          >
            <div className="box bg-white rounded-banget shadow p-4 table-responsive overflow-x-auto">
              <table
                id="dataCalonAgen"
                className="display table w-100"
                width="100%"
                ref={(al) => (this.al = al)}
              ></table>
            </div>
          </div>
          <div className="tab-pane fade" id="waiting" role="tabpanel">
            <div className="box bg-white rounded-banget shadow p-4 table-responsive overflow-x-auto">
              <table
                id="dataCalonAgen"
                className="display table w-100"
                width="100%"
                ref={(el) => (this.el = el)}
              ></table>
            </div>
          </div>
          <div className="tab-pane fade" id="ditolak" role="tabpanel">
            <div className="box bg-white rounded-banget shadow p-4 table-responsive overflow-x-auto">
              <table
                id="dataCalonAgen"
                className="display table w-100"
                width="100%"
                ref={(dul) => (this.dul = dul)}
              ></table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UserManagememt;
